$(function() {
  const BaseModule = require('_base/base')

  class AutoCols extends BaseModule {
    postInit() {
      this.isColumnGrid = this.$el.hasClass('grid__column');

      this.$cols = this.$el.children();
      this.$image = this.$cols.find('.image');
      this.$mainCol = this.$cols.filter('.js__autoCols-main');

      this.gutter = this._getGutter();
      this.compensator = this.isColumnGrid ? this.gutter : 0;
      this.initialImageWidth = this.$image.data('width');
      this.initialImageHeight = this.$image.data('height');
      this.imageRatio = this.initialImageWidth / this.initialImageHeight;
    }

    _getGutter() {
      if (this.isColumnGrid) {
        return this.$el.width() - this.$el.outerWidth(true);
      }

      let gutter = 0;

      this.$cols.each((_, el) => {
        const $col = $(el);
        gutter += $col.outerWidth(true) - $col.width();
      });

      return gutter / (this.$cols.length - 1);
    }

    postReset() {
      this.$mainCol.css({
        'flex-basis': 'none',
        'max-width': 'none',
        height: 'auto',
      });
    }

    postCalculate() {
      this.imageVerticalMargins = parseFloat(this.$image.css('margin-top'))
        + parseFloat(this.$image.css('margin-bottom'));
      this.imageHorizontalMargins = parseFloat(this.$image.css('margin-left'))
        + parseFloat(this.$image.css('margin-right'));

      this.blockPaddings = this.$mainCol.outerWidth() - this.$mainCol.width();
      this.parentInitialHeight = this.$el.height() - this.imageVerticalMargins - this.imageLabelHeight;
      this.parentInitialWidth = this.$el.width() - this.imageHorizontalMargins - this.gutter / 2;
      this.maxImageWidth = this.parentInitialWidth * 2 / 3;

      this.calculatedWidth = this.parentInitialHeight * this.imageRatio + this.blockPaddings;

      if (this.calculatedWidth > this.maxImageWidth) {
        this.calculatedWidth = this.maxImageWidth;
      }

      this.calculatedHeight = (this.calculatedWidth - this.blockPaddings) / this.imageRatio + this.imageVerticalMargins + this.imageLabelHeight

      this.preRender()
    }

    setHeight(height) {
      this.calculatedHeight = height
      this.calculatedWidth = (this.calculatedHeight - this.imageVerticalMargins - this.imageLabelHeight) * this.imageRatio + this.blockPaddings

      this.preRender()
    }

    get imageLabelHeight() {
      return this.$image
        .prev('.image-label')
        .outerHeight(true) || 0
    }

    preRender() {
      this.$mainCol.css({
        'flex-basis': this.calculatedWidth,
        'max-width': this.calculatedWidth + this.compensator,
        height: this.calculatedHeight,
      })
    }
  }

  $('.js__autoCols').each(function() {
    new AutoCols($(this))
  })
})
